import { Component, inject } from '@angular/core';

import { Router, RouterModule } from '@angular/router'; // ✅ importer RouterModule
import { AuthService } from 'src/app/services/auth.service';
import { FounderBannerComponent } from '../founder-banner/founder-banner.component';

@Component({
  selector: 'app-pricing',
  imports: [RouterModule, FounderBannerComponent], // ✅ ajouter RouterModule ici
  templateUrl: './pricing.component.html',
})
export class PricingComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  plans = [
    {
      id: 'free', // ✅ ajout de l'id
      name: 'Free',
      price: '0 €',
      period: '/ mois',
      features: [
        '3 documents / mois',
        'Analyse standard',
        'Historique de 7 jours',
        'Export désactivé',
      ],
      cta: 'Essayer Gratuitement',
      isFeatured: false,
    },
    {
      id: 'starter',
      name: 'Starter',
      price: '29 €',
      period: '/ mois',
      features: [
        '20 documents / mois',
        '5,000 requêtes IA',
        'Analyse avancée',
        'Export PDF',
      ],
      cta: "S'inscrire",
      isFeatured: false,
    },
    {
      id: 'pro',
      name: 'Pro',
      price: '79 €',
      period: '/ mois',
      features: [
        '200 documents / mois',
        'RAG interne',
        "Collaboration d'équipe (3 pers.)",
        'Support prioritaire',
      ],
      cta: "S'inscrire",
      isFeatured: true,
    },
    {
      id: 'business',
      name: 'Business',
      price: '149 €',
      period: '/ mois',
      features: [
        'Documents illimités',
        'Accès API',
        'Vitesse prioritaire',
        'Support 24/7',
      ],
      cta: 'Nous contacter',
      isFeatured: false,
    },
  ];

  trackByPlanName(index: number, plan: any): string {
    return plan.name;
  }

  trackByFeature(index: number, feature: string): string {
    return feature;
  }

  // 👉 C’est ici que le plan est stocké AVANT register
  goToRegister(planId: string) {
    this.authService.setSelectedPlan(planId);
    this.router.navigate(['/register']);
  }
}
